import { Col, Page, PageHeader, Row } from "@tv2no/ui-react";
import React from "react";
import { GeoImport } from "./geo/GeoImport";
import { TaxYearList } from "./tax/list/TaxYearList";

export const DataImport = () => {
    return (
        <Page>
            <PageHeader icon="tools" title="Dataimport" subtitle="Skattelister" />
            <Row>
                <Col span={24}>
                    <TaxYearList />
                </Col>
                <Col span={24}>
                    <GeoImport />
                </Col>
            </Row>
        </Page>
    );
};
